import { render, staticRenderFns } from "./ExpensesForm.vue?vue&type=template&id=f2379498"
import script from "./ExpensesForm.vue?vue&type=script&lang=js"
export * from "./ExpensesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports